import React, { useEffect, useState, forwardRef, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import validateInput from "../../utilities/validations/validateInput";
import Input from "../input/Input";
import { language } from "../../stores/slices/languageSlice";
import { lookUp } from "../../stores/slices/lookupSlice";
import style from "./FinancialResourceDirectory.module.css";
import {
  Phone,
  Link,
  Mail,
  MapPin,
  Download,
  Linkedin,
  Facebook,
  Twitter,
} from "react-feather";
import { useReactToPrint } from "react-to-print";
import Assistance from "./Assistance-1.png";
import video from "./video.png";
import Medical from "./Medical.png";
import asstancePDF from "./asstancePDF.pdf";
import medicalPDF from "./medical.pdf";
import { toast } from "react-toastify";
import {
  oauthApi,
  getResourceArticlesApi,
  resetDropDownValue,
  resetResourceDirectory,
} from "../../stores/slices/financialResourceDirectorySlice";
import { sendEmail } from "../../stores/slices/emailSendSlice";
import Loader from "../menu/Loader";

const ResourceDirectory = () => {
  const dispatch = useDispatch();
  const componentRef = useRef();
  const ResourceDirectoryValues = useSelector(
    (state) => state.financialResourceDirectorySlice.getResourceData
  );
  const ResourceDirectoryLoader = useSelector(
    (state) => state.financialResourceDirectorySlice.getResourceData.loader
  );
  const dropDwondValues = useSelector(
    (state) => state.financialResourceDirectorySlice.dropDwondValues
  );
  const selectedLanguage =
    useSelector(language).Dashboard.resources.resourcesdirectory;
  const lookUpData = useSelector(lookUp);
  const [useEffectCallFlag, setUseEffectCallFlag] = useState(false);
  const [emailFlage, setEmailFlage] = useState(false);
  const [printArray, setPrintArray] = useState([]);
  const [checkBoxArray, setCheckBoxArray] = useState([]);
  const [selectAllBtnTextFlag, setSelectAllBtnTextFlag] = useState(true);
  const [email, setEmail] = useState({
    email: {
      value: "",
      isValid: true,
    },
  });

  const [resourceDetails, setResourceDetails] = useState([]);
  const [filterResource, setFilterResource] = useState(undefined);
  const [searchDetails, setSearchDetails] = useState({
    insurance: {
      value: "",
      isValid: true,
    },
    age_Range: {
      value: "",
      isValid: true,
    },
    residential_State: {
      value: "",
      isValid: true,
    },
    medical_Diagnosis: {
      value: "",
      isValid: true,
    },
    assistance_Type_Needed: {
      value: "",
      isValid: true,
    },
  });
  const [paramData, setParamData] = useState([]);
  const inputOnChange = (e, fieldvalidation) => {
    dispatch(resetResourceDirectory());
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);

    setSearchDetails((prevState) => ({
      ...prevState,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
  };
  const emailOnChange = (e, fieldvalidation) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let inputValidate = validateInput(inputValue, fieldvalidation);

    setEmail((prevState) => ({
      ...prevState,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
  };

  // search button function
  const btnSearch = () => {
    let isFormValidate =
      searchDetails.insurance.value &&
      searchDetails.insurance.isValid &&
      searchDetails.age_Range.value &&
      searchDetails.age_Range.isValid &&
      searchDetails.residential_State.value &&
      searchDetails.residential_State.isValid &&
      searchDetails.assistance_Type_Needed.value &&
      searchDetails.assistance_Type_Needed.isValid &&
      searchDetails.medical_Diagnosis.value &&
      searchDetails.medical_Diagnosis.isValid;

    if (isFormValidate) {
      let requsetData = {
        InsuranceStatus: searchDetails.insurance.value,
        AgeRange: searchDetails.age_Range.value,
        StateorTerritory: searchDetails.residential_State.value,
        AssistanceMain: searchDetails.assistance_Type_Needed.value,
        NURDDxCategoryMain: searchDetails.medical_Diagnosis.value,
      };
      setParamData((prevState) => [
        { InsuranceStatus: searchDetails.insurance.value },
        { AgeRange: searchDetails.age_Range.value },
        { StateorTerritory: searchDetails.residential_State.value },
        { AssistanceMain: searchDetails.assistance_Type_Needed.value },
        { NURDDxCategoryMain: searchDetails.medical_Diagnosis.value },
      ]);
      let params = `InsuranceStatus=${searchDetails.insurance.value}&AgeRange=${searchDetails.age_Range.value}&StateorTerritory=${searchDetails.residential_State.value}&AssistanceMain=${searchDetails.assistance_Type_Needed.value}&NURDDxCategoryMain=${searchDetails.medical_Diagnosis.value}`;
      // dispatch(getResourceArticlesApi({ params }));
      dispatch(
        oauthApi((accessToken) => {
          dispatch(
            getResourceArticlesApi({ accessToken: accessToken, params })
          );
        })
      );
    } else {
      setSearchDetails((prevState) => ({
        ...prevState,
        insurance: {
          value: searchDetails.insurance.value,
          isValid:
            searchDetails.insurance.value && searchDetails.insurance.isValid
              ? true
              : false,
        },
        age_Range: {
          value: searchDetails.age_Range.value,
          isValid:
            searchDetails.age_Range.value && searchDetails.age_Range.isValid
              ? true
              : false,
        },
        residential_State: {
          value: searchDetails.residential_State.value,
          isValid:
            searchDetails.residential_State.value &&
              searchDetails.residential_State.isValid
              ? true
              : false,
        },
        medical_Diagnosis: {
          value: searchDetails.medical_Diagnosis.value,
          isValid:
            searchDetails.medical_Diagnosis.value &&
              searchDetails.medical_Diagnosis.isValid
              ? true
              : false,
        },
        assistance_Type_Needed: {
          value: searchDetails.assistance_Type_Needed.value,
          isValid:
            searchDetails.assistance_Type_Needed.value &&
              searchDetails.assistance_Type_Needed.isValid
              ? true
              : false,
        },
      }));
      toast.error(selectedLanguage.mandatoryToastError);
    }
  };

  // select all Resource Details
  const btnSelectAll = (e) => {
    setSelectAllBtnTextFlag(!selectAllBtnTextFlag);
    if (e.target.innerText === "Select All") {
      setResourceDetails((prevState) =>
        prevState.map((data) =>
          data.isChecked == false ? { ...data, isChecked: true } : data
        )
      );
    } else {
      setResourceDetails((prevState) =>
        prevState.map((data) =>
          data.isChecked == true ? { ...data, isChecked: false } : data
        )
      );
    }
  };

  // function resetFilter
  const btnResetFilter = (index) => {
    setFilterResource((prevState) => {
      const updatedState = {};
      setCheckBoxArray([]);
      // Iterate over each key in prevState and update the array using map
      Object.keys(prevState).map((key) => {
        updatedState[key] = prevState[key].map((item) => ({
          ...item,
          isChecked: item.isChecked && false, // Toggle isChecked
        }));
      });

      return updatedState;
    });
    setParamData((prevState) => [
      { InsuranceStatus: searchDetails.insurance.value },
      { AgeRange: searchDetails.age_Range.value },
      { StateorTerritory: searchDetails.residential_State.value },
      { AssistanceMain: searchDetails.assistance_Type_Needed.value },
      { NURDDxCategoryMain: searchDetails.medical_Diagnosis.value },
    ]);
    let params = `InsuranceStatus=${searchDetails.insurance.value}&AgeRange=${searchDetails.age_Range.value}&StateorTerritory=${searchDetails.residential_State.value}&AssistanceMain=${searchDetails.assistance_Type_Needed.value}&NURDDxCategoryMain=${searchDetails.medical_Diagnosis.value}`;
    dispatch(
      oauthApi((accessToken) => {
        dispatch(getResourceArticlesApi({ accessToken: accessToken, params }));
      })
    );
  };

  // filter function
  const handleResourceFilterCheckbox = (e, index, key, value) => {
    setUseEffectCallFlag(true);
    let inputValue = e.target.value;
    let name = e.target.name;
    setFilterResource((prevState) => ({
      ...prevState,
      [name]: prevState[name].map((data, i) =>
        index == i ? { ...data, isChecked: !data.isChecked } : data
      ),
    }));

    if (e.target.checked) {
      setCheckBoxArray([...checkBoxArray, value + index]);
    } else {
      setCheckBoxArray((prevArr) =>
        prevArr.filter((item) => item !== value + index)
      );
    }
    // update api param
    addKeyValueParam(key, value, e.target.checked);
  };

  const addKeyValueParam = (key, value, checked) => {
    if (checked) {
      setParamData([...paramData, { [key]: value }]);
    } else {
      setParamData((prevArr) => prevArr.filter((obj) => obj[key] !== value));
    }
  };

  useEffect(() => {
    if (useEffectCallFlag) {
      setUseEffectCallFlag(false);
      const paramsD = paramData.reduce((acc, obj) => {
        for (const [key, value] of Object.entries(obj)) {
          if (acc.hasOwnProperty(key)) {
            acc[key] += `;${value}`;
          } else {
            acc[key] = value;
          }
        }
        return acc;
      }, {});

      const params = Object.entries(paramsD)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

      dispatch(
        oauthApi((accessToken) => {
          dispatch(
            getResourceArticlesApi({ accessToken: accessToken, params })
          );
        })
      );
    }
  }, [useEffectCallFlag]);

  // print selected function
  const handleResourceCheckbox = (e, data, index) => {
    setResourceDetails((prevState) =>
      prevState.map((data, i) =>
        index == i ? { ...data, isChecked: !data.isChecked } : data
      )
    );
  };
  const printCallBackFunction = useReactToPrint({
    content: () => componentRef.current,
  });
  // Print Resources Function
  const printResourcesData = () => {
    if (printArray.length >= 1) {
      printCallBackFunction();
    } else {
      toast.error(selectedLanguage?.resourceToPrint);
    }
  };

  // Print Array update function
  const updatePrintArray = () => {
    let print =
      resourceDetails.length >= 1
        ? resourceDetails.filter((resource) => resource.isChecked)
        : [];
    setPrintArray(print);
  };

  // updatePrintArray useEffect
  useEffect(() => {
    updatePrintArray();
  }, [resourceDetails]);
  let array = {};
  useEffect(() => {
    setFilterResource(ResourceDirectoryValues?.getResourceFilterData);
    setResourceDetails(ResourceDirectoryValues?.getResourceArticlesData);
  }, [ResourceDirectoryValues?.getResourceFilterData]);

  // btn Email show hidden
  const btnEmail = () => {
    setEmailFlage(!emailFlage);
  };
  let checkBox = JSON.stringify(checkBoxArray);

  const clickSendEmail = () => {
    let isValidate = email.email.value != "" && email.email.isValid;
    if (isValidate) {
      if (printArray.length >= 1) {
        const container = document.createElement("div");

        printArray.map((x) => {
          const addressDetails = [];

          if (x.StreetAddressLine1 !== "") {
            addressDetails.push(x.StreetAddressLine1);
          }
          if (x.StreetAddressLine2 !== "") {
            addressDetails.push(x.StreetAddressLine2);
          }
          if (x.City !== "") {
            addressDetails.push(x.City);
          }
          if (x.States !== "") {
            addressDetails.push(x.States);
          }
          if (x.ZipCode !== "") {
            addressDetails.push(x.ZipCode);
          }

          const addressString = addressDetails.join(", ");

          const div = document.createElement("div");
          div.className = "pt-3 pb-2";
          div.style.borderBottom = "#1f1f1fac 1px solid";
          div.innerHTML = `
              <div style="display: flex; justify-content: space-between; margin-top:15px">
                  <div>
                      <span style="color: #1c3f94 !important;" class="fs-sm-lg"><b>${!!x.Title ? x.Title : ""
            }</b></span>
                  </div>
                  ${x.OfficePhoneNumber != "" ||
              x.OfficePhoneNumber == undefined
              ? `<div style="display: flex; justify-content: center; align-items: center;">
                          <div class="fs-sm-sm">
                              <b style="color: #1c3f94 !important;" class="fs-sm-lg">${x.OfficePhoneNumber}</b>
                          </div>
                      </div>`
              : ""
            }
              </div>
              <div class="pt-3">
                  <p>${x.Description}</p>
              </div>
              <div class="pt-3">
                  <a href="https://www.${x.Website}" target="_blank"><u>${!!x.Website ? x.Website : ""
            }</u></a>
              </div>
              <div class="pt-3">${!!x.Summary ? x.Summary : ""}</div>
              ${x.Email != "" || x.Email == undefined
              ? `<div class="pt-3"><a href="mailto:${x.Email}">${x.Email}</a></div>`
              : ""
            }
              ${x.StreetAddressLine1 != "" || x.StreetAddressLine1 == undefined
              ? `<div class="pt-3">
                      <a href="http://maps.google.com/?q=${addressString}" target="_blank">
                          ${x.StreetAddressLine1 == "" ||
                x.StreetAddressLine1 == undefined
                ? ""
                : x.StreetAddressLine1
              } &nbsp;
                          ${x.StreetAddressLine2 == "" ||
                x.StreetAddressLine2 == undefined
                ? ""
                : x.StreetAddressLine2
              },&nbsp;${!!x.City ? x.City : ""},&nbsp;${!!x.States ? x.States : ""
              },&nbsp;${!!x.ZipCode ? x.ZipCode : ""}
                      </a>
                  </div>
                  
                  `
              : ""
            }
              <br></br>
              <hr></hr>
          `;
          container.appendChild(div);
        });
        dispatch(
          sendEmail({ email: email.email.value, content: container.innerHTML })
        );
      } else {
        toast.error("Select at least one resource to email.");
      }
    } else {
      setEmail((prevState) => ({
        ...prevState,
        email: {
          value: email.email.value,
          isValid:
            email.email.value != "" && email.email.isValid ? true : false,
        },
      }));
      toast.error("Please enter the valid Email");
    }
  };

  const PrintResourcesComponent = forwardRef((props, ref) => {
    return (
      <div className="px-8 pt-2 pb-2" ref={ref}>
        {printArray?.map((x) => {
          const addressDetails = [];

          if (x.StreetAddressLine1 !== "") {
            addressDetails.push(x.StreetAddressLine1);
          }
          if (x.StreetAddressLine2 !== "") {
            addressDetails.push(x.StreetAddressLine2);
          }
          if (x.City !== "") {
            addressDetails.push(x.City);
          }
          if (x.States !== "") {
            addressDetails.push(x.States);
          }
          if (x.ZipCode !== "") {
            addressDetails.push(x.ZipCode);
          }

          const addressString = addressDetails.join(", ");
          return (
            <div
              className={`pt-3 pb-2 ${style.rightSideMapping_container}`}
              style={{
                borderBottom: "#1f1f1fac 1px solid",
              }}
            >
              <div
                className={`${style.rightSide_header}`}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className="">
                  <span
                    className={`fs-sm-lg`}
                    style={{
                      color: "#1c3f94 !important",
                    }}
                  >
                    <b>{x.Title}</b>
                  </span>
                </div>
                {x.OfficePhoneNumber != "" && (
                  <div
                    className={style.phone_container}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="fs-sm-sm">
                      <b
                        className={`fs-sm-lg ${style.text_color}`}
                        style={{
                          color: "#1c3f94 !important",
                        }}
                      >
                        {x.OfficePhoneNumber}
                      </b>
                    </div>
                  </div>
                )}
              </div>
              <div className="pt-3">
                <p>{x.Description}</p>
              </div>
              <div className="pt-3">
                <a href={`https://www.${x.Website}`} target="_blank">
                  <u>{x.Website}</u>
                </a>
              </div>
              <div className="pt-3">{x.Summary}</div>
              {x.Email != "" && (
                <div className="pt-3">
                  {" "}
                  <a
                    href={`mailto:${x.Email}`}
                    className="lacation"
                    target="_blank"
                  >
                    {x.Email}
                  </a>
                </div>
              )}
              {x.StreetAddressLine1 != "" && (
                <div className="pt-3">
                  <a
                    href={`http://maps.google.com/?q=${addressString}`}
                    className="lacation"
                    target="_blank"
                  >
                    {x.StreetAddressLine1 == "" ? null : x.StreetAddressLine1}
                    &nbsp;
                    {x.StreetAddressLine2 == "" ? null : x.StreetAddressLine2}
                    ,&nbsp;{x.City},&nbsp;{x.States},&nbsp;
                    {x.ZipCode}
                  </a>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  });

  return (
    <>
      <div>
        <div className={`${style.search_details}`}>
          <div className={`p-2 ${style.search_header}`}>
            {selectedLanguage?.searchHeader}
          </div>
          <div className="grid input-fields columns-12 gap-4 gap-y-5 pt-5">
            <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ">
              <Input
                type="select_NFRD"
                id="insurance"
                label={selectedLanguage?.doYouHaveInsurance}
                name="insurance"
                value={searchDetails.insurance.value}
                isValid={searchDetails.insurance.isValid}
                onChange={(e) => inputOnChange(e, "state")}
                errorMsg={selectedLanguage?.inputErrorMessage}
                elmentconfig={dropDwondValues?.insurance_dropDownValue}
              />
            </div>
            <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4">
              <Input
                type="select_NFRD"
                id="age_Range"
                label={selectedLanguage?.ageRange}
                name="age_Range"
                value={searchDetails.age_Range.value}
                isValid={searchDetails.age_Range.isValid}
                onChange={(e) => inputOnChange(e, "state")}
                errorMsg={selectedLanguage?.inputErrorMessage}
                elmentconfig={dropDwondValues?.ageRange_dropDownValue}
              />
            </div>
            <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4">
              <Input
                type="select_NFRD"
                id="residential_State"
                label={selectedLanguage.residentialState}
                name="residential_State"
                value={searchDetails.residential_State.value}
                isValid={searchDetails.residential_State.isValid}
                onChange={(e) => inputOnChange(e, "state")}
                errorMsg={selectedLanguage?.inputErrorMessage}
                elmentconfig={dropDwondValues?.state_dropDownValue}
              />
            </div>
          </div>
          <div className="grid input-fields columns-12 gap-4 gap-y-5 pb-8 pt-5">
            <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4">
              <Input
                type="select_NFRD"
                id="medical_Diagnosis"
                label={selectedLanguage.medicalDiagnosis}
                name="medical_Diagnosis"
                value={searchDetails.medical_Diagnosis.value}
                isValid={searchDetails.medical_Diagnosis.isValid}
                onChange={(e) => inputOnChange(e, "state")}
                errorMsg={selectedLanguage?.inputErrorMessage}
                elmentconfig={dropDwondValues?.medicalDiagnosis_dropDownValue}
              />
            </div>
            <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ">
              <Input
                type="select_NFRD"
                id="assistance_Type_Needed"
                label={selectedLanguage.assistanceTypeNeeded}
                name="assistance_Type_Needed"
                value={searchDetails.assistance_Type_Needed.value}
                isValid={searchDetails.assistance_Type_Needed.isValid}
                onChange={(e) => inputOnChange(e, "state")}
                errorMsg={selectedLanguage?.inputErrorMessage}
                elmentconfig={dropDwondValues?.Assistance_dropDownValue}
              />
            </div>
            <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 px-6 pt-6">
              <button
                className="btn btn-yellow fs-base reset-btn ms-3"
                onClick={btnSearch}
              >
                <p class="px-3">{selectedLanguage?.search}</p>
              </button>
            </div>
          </div>
        </div>
        <br></br>
        <br></br>
        {ResourceDirectoryValues?.displayArticlesFlag && (
          <>
            <div className={`${style.search_details}`}>
              <div className="grid input-fields columns-12 gap-4 gap-y-5 pt-8 pb-8">
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 ms-8">
                  <p className={style.Criteria_selected}>
                    <b>Search Criteria Selected:&nbsp;</b>
                    {searchDetails.insurance.value},&nbsp;
                    {searchDetails.age_Range.value},&nbsp;
                    {searchDetails.residential_State.value},&nbsp;
                    {searchDetails.medical_Diagnosis.value},&nbsp;
                    {searchDetails.assistance_Type_Needed.value}
                    <br></br>
                    {ResourceDirectoryValues.totalCount} Result(s) found
                  </p>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 text-center  pt-3">
                  <button
                    className={`btn btn-yellow fs-base  ms-4`}
                    onClick={printResourcesData}
                  >
                    <p className="px-3">{selectedLanguage?.printResources}</p>
                  </button>
                </div>
                <div className="intro-y g-col-12 g-col-md-4 g-col-xl-4 text-center pt-3">
                  <button
                    className={`btn btn-yellow fs-base ms-4`}
                    onClick={btnEmail}
                  >
                    <p className="px-3">{selectedLanguage?.emailResources}</p>
                  </button>
                </div>
              </div>
            </div>
            <br></br>
            {emailFlage && (
              <div className={`${style.email_container}`}>
                <div className={`${style.emailInput_container}`}>
                  <div className="">
                    <Input
                      type="email"
                      id="email"
                      label={selectedLanguage?.email}
                      name="email"
                      value={email.email.value}
                      isValid={email.email.isValid}
                      onChange={(e) => emailOnChange(e, "email")}
                      errorMsg={selectedLanguage?.inputErrorMessage}
                    />
                  </div>
                  <div className=" pt-5">
                    <button
                      onClick={clickSendEmail}
                      className={`btn btn-yellow fs-base`}
                    >
                      <p className="">{selectedLanguage?.sendEmail}</p>
                    </button>
                  </div>
                </div>
              </div>
            )}
            <br></br>
            <div className="row ms-1">
              <div className={`col-md-4 ${style.leftSide_container} pt-6 pb-3`}>
                <div className="text-center">
                  <button
                    className={`btn btn-yellow fs-base ms-4`}
                    onClick={btnResetFilter}
                  >
                    <p className="px-3">{selectedLanguage?.resetFilter}</p>
                  </button>
                </div>
                {filterResource &&
                  Object.keys(filterResource).map((keys, index) => {
                    return (
                      <>
                        <div className="pt-6" key={index}>
                          <p className={`fs-sm-lg ${style.text_color}`}>
                            <b>{keys}</b>
                          </p>
                        </div>
                        <div>
                          {filterResource[keys].map((x, index) => {
                            return (
                              <>
                                <div className="ms-3">
                                  <span key={index}>
                                    <Input
                                      key={x.key}
                                      type="checkboxNFRD"
                                      id={x.key}
                                      labelPosition="left"
                                      name={keys}
                                      label={x.value}
                                      value={x.value}
                                      checked={
                                        checkBox.includes(x.value + index)
                                          ? true
                                          : false
                                      }
                                      onClick={(e) =>
                                        handleResourceFilterCheckbox(
                                          e,
                                          index,
                                          x.key,
                                          x.value
                                        )
                                      }
                                    />
                                    {` (${x.count})`}
                                  </span>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </>
                    );
                  })}
              </div>
              <div
                className={`col-md-8 ${style.rightSide_container} pt-6 pb-3`}
              >
                <div>
                  <button
                    style={{ width: "136px" }}
                    className={`btn btn-yellow fs-base ms-4`}
                    onClick={btnSelectAll}
                  >
                    <p className="px-3">
                      {selectAllBtnTextFlag
                        ? selectedLanguage?.selectAll
                        : selectedLanguage?.deSelectAll}
                    </p>
                  </button>
                </div>
                <div>
                  {resourceDetails.length >= 1
                    ? resourceDetails.map((x, index) => {
                      const addressDetails = [];

                      if (x.StreetAddressLine1 !== "") {
                        addressDetails.push(x.StreetAddressLine1);
                      }
                      if (x.StreetAddressLine2 !== "") {
                        addressDetails.push(x.StreetAddressLine2);
                      }
                      if (x.City !== "") {
                        addressDetails.push(x.City);
                      }
                      if (x.States !== "") {
                        addressDetails.push(x.States);
                      }
                      if (x.ZipCode !== "") {
                        addressDetails.push(x.ZipCode);
                      }

                      const addressString = addressDetails.join(", ");
                      return (
                        <>
                          <div
                            key={index}
                            className={`pt-3 pb-2 ${style.rightSideMapping_container}`}
                          >
                            <div className={`${style.rightSide_header}`}>
                              <div className="">
                                <span
                                  className={`fs-sm-lg ${style.text_color}`}
                                >
                                  <Input
                                    className="text_color"
                                    type="checkboxNFRD"
                                    id="policyCheckbox"
                                    labelPosition="left"
                                    name="privacy_policy_checkbox"
                                    label={x.Title}
                                    value={x.isChecked}
                                    checked={x.isChecked}
                                    onClick={(e) =>
                                      handleResourceCheckbox(e, x, index)
                                    }
                                  />
                                </span>
                              </div>
                              {x.OfficePhoneNumber != "" && (
                                <div className={style.phone_container}>
                                  <div className="fs-sm-sm">
                                    <span className={style.icon_style}>
                                      <Phone className={style.phone} />
                                    </span>{" "}
                                    <b
                                      className={`fs-sm-lg ${style.text_color}`}
                                    >
                                      {x.OfficePhoneNumber}
                                    </b>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="pt-3">
                              <p>{x.Description}</p>
                            </div>
                            <div className="pt-3">
                              <span className={style.icon_style}>
                                {" "}
                                <Link className={style.phone} />
                              </span>{" "}
                              &nbsp;
                              <a
                                href={`https://www.${x.Website}`}
                                target="_blank"
                              >
                                <u>{x.Website}</u>
                              </a>
                            </div>
                            <div className="pt-3">{x.Summary}</div>
                            {x.Email != "" && (
                              <div className="pt-3">
                                <span className={style.icon_style}>
                                  <Mail className={style.phone} />
                                </span>
                                &nbsp;
                                <a
                                  href={`mailto:${x.Email}`}
                                  className="lacation"
                                  target="_blank"
                                >
                                  {x.Email}
                                </a>
                              </div>
                            )}
                            {x.StreetAddressLine1 != "" && (
                              <div className="pt-3">
                                <span className={style.icon_style}>
                                  <MapPin className={style.phone} />
                                </span>
                                &nbsp;
                                <a
                                  href={`http://maps.google.com/?q=${addressString}`}
                                  className="lacation"
                                  target="_blank"
                                >
                                  {x.StreetAddressLine1 == ""
                                    ? null
                                    : x.StreetAddressLine1}
                                  &nbsp;
                                  {x.StreetAddressLine2 == ""
                                    ? null
                                    : x.StreetAddressLine2}
                                  ,&nbsp;{x.City},&nbsp;{x.States},&nbsp;
                                  {x.ZipCode}
                                </a>
                              </div>
                            )}
                          </div>
                        </>
                      );
                    })
                    : null}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      <div className={`p-2 pt-4 mt-6 ${style.linkDetail}`}>
        <div className="row d-flex align-items-center">
          <div className="col-md-8">
            <p style={{ fontSize: "15px" }}>
              <span className="fs-sm-lg">
                <b>Tell us about your resource!</b>
              </span>{" "}
              If you are part of, or know of, an organization that provides
              services or financial aid to benefit individuals with a chronic
              illness please{" "}
              <a
                href="https://www.patientadvocate.org/suggest-a-program-for-our-resource-list/  "
                title="resource-list"
                target="_blank"
                className={style.link}
              >
                share some details about it.
              </a>{" "}
              Our internal research team will review and add it to the directory
              if it matches the vision and scope of our tool.
            </p>
            {/* <p className={`pt-6`} style={{ fontSize: "15px" }}>
              <span className="fs-sm-lg">
                <b>Disclaimer:</b>
              </span>{" "}
              This tool identifies external programs and organizations that may
              be able to assist patients based on entered selection criteria.
              The resource list is offered as a courtesy to users and does not
              imply any level of endorsement. Neither Patient Advocate
              Foundation nor Patient Action Council have any direct connection
              to these resources, and thus no influence on eligibility criteria,
              selection process, fund availability and cannot guarantee any
              level of support. Secondary filters allow users to find resources
              that are specific to them, however, users may still benefit from
              the other resources generated by their search. For example,
              resources within the Armed Forces filter are exclusive to those
              individuals.
            </p> */}
            <div>
              <p
                className="mt-5 pt-6"
                style={{ color: "#152C8C", fontSize: "24px" }}
              >
                <b>Share</b>
              </p>
              <div className="d-flex mt-3">
                <a
                  href={`https://www.addtoany.com/add_to/facebook?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="facebook"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.fb_icon}`}>
                    <Facebook />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/twitter?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  target="_blank"
                  title="twitter"
                  className="p-1"
                >
                  <span className={`${style.tw_icon}`}>
                    <Twitter />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/email?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="email"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.ma_icon}`}>
                    <Mail />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/linkedin?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="linkedin"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.li_icon}`}>
                    <Linkedin />
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-4" >
            <div>
              <a
                href={`https://vimeo.com/822986118/0fcf4fc711?share=copy`}
                title="vimeo"
                target="_blank"
              >
                <img alt="vimeo" src={video}></img>
              </a>
            </div>
            {/* <div>
              <p
                className="mt-5"
                style={{ color: "#152C8C", fontSize: "24px" }}
              >
                <b>Share</b>
              </p>
              <div className="d-flex mt-3">
                <a
                  href={`https://www.addtoany.com/add_to/facebook?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="facebook"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.fb_icon}`}>
                    <Facebook />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/twitter?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  target="_blank"
                  title="twitter"
                  className="p-1"
                >
                  <span className={`${style.tw_icon}`}>
                    <Twitter />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/email?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="email"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.ma_icon}`}>
                    <Mail />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/linkedin?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="linkedin"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.li_icon}`}>
                    <Linkedin />
                  </span>
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className={`p-2 mt-8 ${style.linskContainer}`}>
        <div className="pt-5">
          <p className="noAction_text">
            Guides to the National Financial Resource Directory
          </p>
        </div>
        <div className="row pt-3 pb-5">
          <div className="col-md-6">
            <div class="intro-x">
              <div class="box px-5 py-3 mb-3 d-flex align-items-center zoom-in">
                <div>
                  <img
                    style={{ width: "160px" }}
                    alt="assistance"
                    src={Assistance}
                  />
                </div>
                <div class="ms-4 me-auto">
                  <div class="text-gray-600 fs-lg mt-0.5">
                    Guide to Assistance Types in the National Financial Resource
                    Directory
                  </div>
                  <div class="text-theme-9 text-end pt-5 mt-3">
                    <a
                      style={{ width: "111px" }}
                      href={
                        "https://www.patientadvocate.org/download-view/guide-to-assistance-types-in-the-national-financial-resource-directory/"
                      }
                      target="_blank"
                      className="btn btn-yellow fs-base reset-btn ps-3"
                    >
                      {" "}
                      DOWNLOAD
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div class="intro-x">
              <div class="box px-5 py-3 mb-3 d-flex align-items-center zoom-in">
                <div>
                  <img
                    style={{ width: "160px" }}
                    alt="assistance"
                    src={Assistance}
                  />
                </div>
                <div class="ms-4 me-auto">
                  <div class="text-gray-600 fs-lg mt-0.5">
                    Guide to Medical Diagnoses in the National Financial
                    Resource Directory
                  </div>
                  <div class="text-theme-9 text-end pt-5 mt-3">
                    <a
                      style={{ width: "111px" }}
                      href={
                        "https://www.patientadvocate.org/download-view/medical-diagnosis-guide-for-national-financial-resource-directory/"
                      }
                      target="_blank"
                      className="btn btn-yellow fs-base reset-btn ps-3"
                    >
                      {" "}
                      DOWNLOAD
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`p-2 pt-4 mt-6 ${style.linkDetail}`}>
        <div className="row">
          <div className="col-md-12">
            {/* <p style={{ fontSize: "15px" }}>
              <span className="fs-sm-lg">
                <b>Tell us about your resource!</b>
              </span>{" "}
              If you are part of, or know of, an organization that provides
              services or financial aid to benefit individuals with a chronic
              illness please{" "}
              <a
                href="https://www.patientadvocate.org/suggest-a-program-for-our-resource-list/  "
                title="resource-list"
                target="_blank"
                className={style.link}
              >
                share some details about it.
              </a>{" "}
              Our internal research team will review and add it to the directory
              if it matches the vision and scope of our tool.
            </p> */}
            <p className={`pt-6`} style={{ fontSize: "15px" }}>
              <span className="fs-sm-lg">
                <b>Disclaimer:</b>
              </span>{" "}
              This tool identifies external programs and organizations that may
              be able to assist patients based on entered selection criteria.
              The resource list is offered as a courtesy to users and does not
              imply any level of endorsement. Neither Patient Advocate
              Foundation nor Patient Action Council have any direct connection
              to these resources, and thus no influence on eligibility criteria,
              selection process, fund availability and cannot guarantee any
              level of support. Secondary filters allow users to find resources
              that are specific to them, however, users may still benefit from
              the other resources generated by their search. For example,
              resources within the Armed Forces filter are exclusive to those
              individuals.
            </p>
          </div>
          {/* <div className="col-md-4" style={{ padding: "0px 0px 0px 37px" }}>
            <div>
              <a
                href={`https://vimeo.com/822986118/0fcf4fc711?share=copy`}
                title="vimeo"
                target="_blank"
              >
                <img alt="vimeo" src={video}></img>
              </a>
            </div>
            <div>
              <p
                className="mt-5"
                style={{ color: "#152C8C", fontSize: "24px" }}
              >
                <b>Share</b>
              </p>
              <div className="d-flex mt-3">
                <a
                  href={`https://www.addtoany.com/add_to/facebook?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="facebook"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.fb_icon}`}>
                    <Facebook />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/twitter?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  target="_blank"
                  title="twitter"
                  className="p-1"
                >
                  <span className={`${style.tw_icon}`}>
                    <Twitter />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/email?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="email"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.ma_icon}`}>
                    <Mail />
                  </span>
                </a>
                <a
                  href={`https://www.addtoany.com/add_to/linkedin?linkurl=https%3A%2F%2Fwww.patientadvocate.org%2Fexplore-our-resources%2Fnational-financial-resource-directory%2F&linkname=National%20Financial%20Resource%20Directory&linknote=`}
                  title="linkedin"
                  target="_blank"
                  className="p-1"
                >
                  <span className={`${style.li_icon}`}>
                    <Linkedin />
                  </span>
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      <div style={{ display: "none" }}>
        <PrintResourcesComponent ref={componentRef} />
      </div>
      {ResourceDirectoryLoader && <Loader />}
    </>
  );
};
export default ResourceDirectory;
